module.exports = __webpack_public_path__ + "img/sjgk.2db9cb72.png";